import rem from 'polished/lib/helpers/rem';

const _rem = (size: string | number) => rem(size, '18px');

export default _rem;